import column from './column.vue';
export default {
    components: {
        column
    },
    data: function() {
        return {
            title: '',
            html: '',
            columns: [],
            bgType: '',
            bgColor: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            maskOption: {
                "showMask": false,
                "maskColor": "rgba(0, 0, 0, 0.7)"
            },
            columnbgColor: '',
            mobileNoMargin: false,
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png'
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        useBgSrc() {
            if (!this.isMobileSize) {
                return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
            } else {
                return this.bgImgOpt.mobileSrc || this.bgImgOpt.src;
            }
        }
    }
};
